export default {"src":"/_next/static/media/walk.65122b6d.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};